import React, { memo } from 'react';

import { LoadedContent } from '../../common/types';

import ShowMoreLinesButton from './show-more-lines-button';

type OwnProps = {
  before: LoadedContent;
  heading: string;
  onShowMoreLines: (shouldExpandDown: boolean) => void;
  isDummyChunk?: boolean;
  isLoadingAbove?: boolean;
  isLoadingBelow?: boolean;
  isFirstChunk: boolean;
  isLastChunk: boolean;
};

export const ChunkHeader: React.FC<OwnProps> = memo(
  ({
    heading,
    before,
    isLoadingAbove,
    isLoadingBelow,
    onShowMoreLines,
    isDummyChunk,
    isFirstChunk,
    isLastChunk,
  }) => {
    const expandDownButton = (
      <ShowMoreLinesButton
        hasMoreLines={before.hasMoreLines}
        onShowMoreLines={() => onShowMoreLines(true)}
        isLoading={!!isLoadingBelow}
        isDummyChunk={isDummyChunk}
        shouldExpandDown
      />
    );

    const expandUpButton = (
      <ShowMoreLinesButton
        hasMoreLines={before.hasMoreLines}
        onShowMoreLines={() => onShowMoreLines(false)}
        isLoading={!!isLoadingAbove}
        isDummyChunk={isDummyChunk}
        shouldExpandDown={false}
      />
    );

    const renderExpandButtons = () => {
      if (isFirstChunk) {
        return expandUpButton;
      } else if (isLastChunk) {
        return expandDownButton;
      } else {
        return (
          <>
            {expandDownButton} {expandUpButton}
          </>
        );
      }
    };

    const renderChunkHeading = () => {
      if (isFirstChunk || isLastChunk) {
        return <div className="chunk-heading">{heading}</div>;
      }
      return <div className="chunk-heading-middle">{heading}</div>;
    };

    return (
      <div className="chunk-heading-wrapper gutter-width-apply-padding-left">
        <div className="show-more-lines-wrapper">{renderExpandButtons()}</div>
        {renderChunkHeading()}
      </div>
    );
  }
);
